/* eslint-disable no-unused-vars */
import React from 'react'
import { connect } from 'react-redux'
import { setUserInfo, setBanner } from '../libs/action'
import { Api } from '../libs/api'
import TopBanner from './topBanner'
import Head from './head'
import Orderhead from './orderhead'
import Menu from './menu'
import { getRandom } from '../../common/util/util'
import Wing from './wing'
import LeftWing from './leftwing'
import { Api as API } from "basic/libs/api";
import styled from "styled-components"


window.isMiniShop = window.isMiniShop || false

if (window.location.hostname === `minishop.pping.${process.env.REACT_APP_TLD}` || window.location.hostname === `react_minishop.pping.${process.env.REACT_APP_TLD}`) {
    window.isMiniShop = true
}
class App extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            mainTopBanner: [],
            mainTopBannerVisible: true,
            headerRightBanner: [],
            miniShopInfo: {},
            headerHeight: 'auto',
            fixMode: false,
            isMinishopDetail : false,
            confirmMinishopDetail : false,
            mainLogo: { desktopLogo: '', seasonLogo: '', desktopFixLogo: '' }
        }
        this.domain = window.location.hostname.split('.')[0] // domain
        this.random = 0
        this.header = document.querySelector('#header')
        this.headFixY = window.isMainDisplay ? 630 : 277 // 디폴트 헤드변경 위치값
        this.mainVisOffset = 355 // 메인 비주얼 배너에서 위에서 어느정도 위치에서 헤더고정할껀지
        this.headerMinHeight = 195 // header 최소 높이값
    }

    componentWillMount() {
       this.validateMinishopDetail().then(r => {
           this.setState({confirmMinishopDetail:true})
       })
    }

    getMinishopLogo = (idx_b_manager) => {
        Api.getMinishopLogo(idx_b_manager).then(res => {
            const { desktopLogo, seasonLogo, desktopFixLogo } = res.data.result
                this.setState({ mainLogo: {
                        desktopLogo,
                        seasonLogo,
                        desktopFixLogo
                    }}
                )
            }
        )
    }

    getBanner() {
        Api.getMainBanner().then(rst => {
            if (rst.data.code === 200) {
                let mainTop = rst.data.result.mainTop
                if (window.location.hostname === `shopping.pping.${process.env.REACT_APP_TLD}`) {
                    mainTop = rst.data.result.shoppingTop
                } else if (window.location.hostname !== `www.pping.${process.env.REACT_APP_TLD}`) {
                    mainTop = rst.data.result.estTop
                }
                const headerRight = rst.data.result.headerRight
                this.random = getRandom(0, mainTop.length, 'min')
                this.setState({ mainTopBanner: mainTop, headerRightBanner: headerRight })
                this.props.setBanner(rst.data.result)
            }
        })
    }

    componentDidMount() {
        this.header = document.querySelector('#header .header_wrapper')
            ? document.querySelector('#header .header_wrapper')
            : document.querySelector('#header')

        if (window.isMiniShop) {
                Api.getMallInfo(window.shopID, window.shopNO).then(rst => {
                    if (rst.data.desc === 'success' && typeof rst.data.data.manager[0] !== 'undefined') {
                        let miniShopInfo = rst.data.data.manager[0]
                        miniShopInfo.shopNO = miniShopInfo.idx_b_manager
                        miniShopInfo.shopName = miniShopInfo.mall_name
                        miniShopInfo.shopID = miniShopInfo.mall_web_user
                        window.shopID = miniShopInfo.mall_web_user
                        window.shopNO = miniShopInfo.shopNO
                        this.setState({ miniShopInfo: miniShopInfo })
                        this.getMinishopLogo(miniShopInfo.shopNO)
                    }else {
                        window.location.href = `https://www.pping.${process.env.REACT_APP_TLD}/sorry`
                    }
                })
            } else {
            this.getMinishopLogo(1)
        }

        this.getBanner()
        this.consoleText()

        setTimeout(() => {
            const firstPathname = this.getFirstPathName()
            if (
                window.isMainDisplay ||
                this.domain === 'search' ||
                (
                    (firstPathname === 'list' || firstPathname === '') &&
                    (this.domain === 'shopping' || this.domain === 'pc' || this.domain === 'minishop' || this.domain === 'notebook')
                )
            ) {
                this.scroll()
                window.addEventListener('scroll', this.scroll) // 메인, (쇼핑 리스트, 견적 리스트)에서만 헤더변형 사용
            }
        }, 500)
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.scroll)
    }

    onBannerClose() {
        this.setState({ mainTopBannerVisible: false })
        setTimeout(() => { this.headerHeightSize() }, 10)
    }

    headerHeightSize = () => {
        this.setState({
            headerHeight: this.header.offsetHeight < this.headerMinHeight
                ? this.state.headerHeight
                : this.header.offsetHeight
        })
    }

    scroll = () => {
        const scrollTop = window.scrollY
        if (scrollTop > this.headFixY) {
            this.setState({
                fixMode: true,
            })
            this.headerHeightSize()
        } else {
            this.setState({
                fixMode: false
            })
            this.headerHeightSize()
            this.headFixY = window.isMainDisplay ? this.mainVisOffset + this.state.headerHeight : this.state.headerHeight
        }
    }

    consoleText = () => {
        const isIE = /*@cc_on!@*/false || !!document.documentMode
        const c1 = 'color:#e5001d'
        const c2 = 'color:#818181'
        const c3 = 'color:#7bbd39'
        const f1 = 'font-size:11px;line-height:30px;color:#0068b3'
        const f2 = 'font-size:11px;line-height:30px;color:#e5001d'
        const f3 = 'font-size:11px;line-height:30px;color:#f4a100'
        if (isIE) {
            console.log('  _  _                     ___ _                  _           \n | || |__ _ _ __ _ __ _  _/ __| |_  ___ _ __ _ __(_)_ _  __ _\n | __ / _` | \'_ \\ \'_ \\ || \\__ \\ \' \\/ _ \\ \'_ \\ \'_ \\ | \' \\/ _` |\n |_||_\\__,_| .__/ .__/\\_, |___/_||_\\___/ .__/ .__/_|_||_\\__, |\n           |_|  |_|   |__/             |_|  |_|         |___/\n                새로운 연결 행복한 쇼핑 행복한 세상')
        } else {
            console.log('%c  _  _                     %c___ %c_                  _           \n %c| || |%c__ _ _ __ _ __ _  _%c/ __| %c|_  ___ _ __ _ __(_)_ _  __ _\n %c| __ %c/ _` | \'_ \\ \'_ \\ || %c\\__ \\ %c\' \\/ _ \\ \'_ \\ \'_ \\ | \' \\/ _` |\n %c|_||_%c\\__,_| .__/ .__/\\_, %c|___/%c_||_\\___/ .__/ .__/_|_||_\\__, |\n           |_|  |_|   |__/             |_|  |_|         |___/\n                %c새로운 연결 %c행복한 쇼핑 %c행복한 세상',c1,c3,c2,c1,c2,c3,c2,c1,c2,c3,c2,c1,c2,c3,c2,f1,f2,f3)
        }
    }

    getFirstPathName = () => {
        return window.location.pathname.split('/')[this.domain === 'minishop'
            ? 2
            : (this.domain === 'shopping' || this.domain === 'pc') ? 1 : 0
        ] || ''
    }

    // 미니샵 상세페이지의 경우 shopping 도메인이기 때문에 검증하여 gnb 메뉴 유지
    validateMinishopDetail = async () => {
        const host = window.location.hostname.split('.')[0]
        const firstPathName = window.location.pathname.split('/')[1]
        if (host === 'shopping' && firstPathName === 'detail'){
            const thirdPathNameNumber = window.location.pathname.split('/')[3]
            let minishopMallName = ''

            if (thirdPathNameNumber){
                try {
                    const miniShopInfoResult = await API.getMallInfoToNumber(thirdPathNameNumber)
                    if (miniShopInfoResult.data.desc === 'success' && typeof miniShopInfoResult.data.data.manager[0] !== 'undefined'){
                        minishopMallName = miniShopInfoResult.data.data.manager[0].mall_web_user
                    }
                } catch (e) {
                    console.error(e)
                }
                if (minishopMallName){
                    try {
                        const minishopMallInfo = await Api.getMallInfo(minishopMallName)
                        if (minishopMallInfo.data.desc === 'success' && typeof minishopMallInfo.data.data.manager[0] !== 'undefined'){
                            const minishopDetailInfo = minishopMallInfo.data.data.manager[0]
                            this.setState({ miniShopInfo: minishopDetailInfo, isMinishopDetail : true})
                        }
                    } catch (e) {
                        console.error(e)
                    }
                }
            }
        }
    }

    render() {
        const { fixMode } = this.state
        const host = window.location.hostname.split('.')[0]

        if (host !== 'shopping') {
            if (window.isMiniShop) {
                if (this.state.miniShopInfo.shopName === undefined) {
                    return false
                }
            }
        }
        let mainTopBanner = []
        if (this.state.mainTopBanner.length > 0) {
            mainTopBanner = this.state.mainTopBanner[this.random]
        }
        return (
            <Wrapper>
                <div
                    className={`head_full_wrap ${fixMode ? 'header_fix': ''}`}
                    style={{ height: `${this.state.headerHeight === 'auto' ? 'auto' : this.state.headerHeight+'px'}`}}
                >
                    <div className="head_full">
                        <div className="header_wrapper">
                            <TopBanner
                                key="topBanner"
                                mainTopBanner={mainTopBanner}
                                onBannerClose={() => this.onBannerClose()}
                                mainTopBannerVisible={this.state.mainTopBannerVisible}
                            />
                            {/* 주문페이지 분기처리 운영배포 */}
                            {this.state.confirmMinishopDetail &&(
                                <>
                                    {(this.domain === 'order') && (<Orderhead key="head" headerRightBanner={this.state.headerRightBanner} miniShopInfo={this.state.miniShopInfo} fixMode={fixMode} mainLogo={this.state.mainLogo} />)}
                                    {!(this.domain === 'order') && (<Head key="head" headerRightBanner={this.state.headerRightBanner} miniShopInfo={this.state.miniShopInfo} fixMode={fixMode} isMinishopDetail={this.state.isMinishopDetail} mainLogo={this.state.mainLogo}/>)}
                                    {!(this.domain === 'order') && (<Menu key="menu" miniShopInfo={this.state.miniShopInfo} fixMode={fixMode} isMinishopDetail={this.state.isMinishopDetail} />)}
                                </>
                            )}
                        </div>
                    </div>
                </div>
                {/* stdpc leftwing 배포 */}
                <LeftWing key="leftWing" mainTopBannerVisible={this.state.mainTopBannerVisible}/>
                <Wing key="wing" mainTopBannerVisible={this.state.mainTopBannerVisible} />
            </Wrapper>
        )
    }
}

let stateData = state => {
    return {
        userInfo: state.user.userInfo,
    }
}

let dispatchData = dispatch => {
    return {
        setUserInfo: userInfo => dispatch(setUserInfo(userInfo)),
        setBanner: banner => dispatch(setBanner(banner)),
    }
}

export default connect(
    stateData,
    dispatchData,
)(App)


const Wrapper = styled.div`
    .gnb_layer {
        position: absolute !important;
        left: 0 !important;
        display: flex !important;
        height: 426px !important;
    }

    .header_fix {
        .header_wrapper {
            .HBottom .GNCAllBtn.on {
                color: #fff !important;
                border: 1px solid #418ded !important;
            }
            .HBottom .gnb_layer {
                position: absolute !important;
                left: -1px !important;
                display: flex !important;
                height: 426px !important;
            }
        }
    }
    @media (max-width: 1209px){
        .gnb_layer {
            position: absolute !important;
            left: 0 !important;
            display: flex !important;
            height: 426px !important;
        }

        .header_fix {
            .header_wrapper {
                width: 950px !important;
                margin: 0 auto !important;

                .HBottom .GNCAllBtn.on {
                    color: #fff !important;
                    border: 1px solid #418ded !important;
                }

                .HBottom .gnb_layer {
                    position: absolute !important;
                    left: -1px !important;
                    display: flex !important;
                    height: 426px !important;
                }
            }
        }
    }
`



// WEBPACK FOOTER //
// ./src/header/component/App.js